var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.373047,
    width: 50,
    height: 50,
    fill: "url(#pattern0_438_1408)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_438_1408",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_438_1408",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_438_1408",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD1UlEQVR4nO2du2sVQRSHVyVqTFDBRhCrYCG+KmMstBBtTROD2NmI5J/QQiJiEbWzEBRTWWgtiIV2VlYmRBvFByjER0RDUD9ZmWIz3Lh3d2buPTf7+7rA3jOz57szZ7N32ZNlQgghhBBCCNEDAH3AGDANzADfEQsuF9MuN32dkjEKzCn/peQ5Gk0pYi1wuXweosAfYDLPXQohklGfyRTbVG67yE9gChgGBrKGAwy4XFxzuSmS5+5kzALu14zXwN4oA6xCgH3AGy9nc1EKvbti8FeGZLQnZdHL3VgWiruMKzIVHLQhANe93N2NEXTWC3owymwbAHDIy91sjKD5PzxFBqPMtgEAg17uFmIEXUaUmTYIYudPQsKQEGNIiDEkxBgSYgwJMYaEGENCVgDoB04BN4FnwEdgCfgFzLsbpk+BW8B54ACwLgtEQjyALcAll/Sq5Hcp7jmRG7MaSEgB4ATwjjh8Ai5kFZEQB3DObUdRySoiIdm/JIwDv1vk8637Re84MOR+5VsPbHN/HwMmgNvuWAkJBdgBfPEyueTqSH/FWIe1QgIBHnhJzLet0wHxtGXVBTjSYpeZqB1QQsLIfyL1ZDwB1gTG1AqpA7AV+OHl71iEuBJSh/y5Jy93r9pZHe4q6yxw3z2q4/9kLSF1cFdRRa618ZndwMv/CZCQmgAPveSdaeOWynsqUmNeQZ9PHzARwAtvqntKjr9YVYaEVAD44OVue8nxz73j7wBHgZ3Apipjl4zT2BWy6E11Q8nxfvFO8sB4k4UsI/bxnZpX5wMmgorzlBAJ+UfHv3ndgorz7NR5rXohtEmsOC0YD5lv0MknCdj7QoZC5ht08kkC9raQ+ap3jyUkrZBHVWQ0UkiWdqyr3nBXasSQkFgAj0MKuoshITHIawXwOaSguzgSEgNgV2hBd3EkJAb5kyqhBd3FkRArBb2RQlYiVpyQgt5qnFonnTRg7woZijHfWiedNGBvCpmv+3yXhKQRUqugN0JIrHl26rwkxCEhXQYPCZGQKF+UzgdMBFohtkBCbIGE2AIJsQUSYgskxBZIiC2QEFsgIbZAQmyBhNgCCbEFEmILJMQWSIgtkBBbICG2oEFCvvVCQxcMCgE2e8N8TdHyaDgzCDaFjKRoeTRd9bVH3QCbQm6kaArWqm3evswYGBPiXlWepG3eSo0lTUnBkBBgf7LGkv9pvbro+vSNWCj0dFmI68g24rapxWStVwsDqjmxlebEhfbdky1WiuhG+27v7Z9qcF/OXPRtqqTQj7lL4pmyV6s2hAX33se7LjdxCrgQQgghhBBCZGn5C87MLMu/QulWAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.1d4f8fd51c8f54e94944bb24f45f879e.svg";
export { ForwardRef as ReactComponent };